// ===== PURE & APPLIED SCIENCES =====
const PURE_SCIENCES = [
  {
    id: "bsc-physics",
    name: "B.Sc Physics",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Fundamental physics: mechanics, electromagnetism, quantum physics, thermodynamics, and experimental lab work.",
    eligibility: "10+2 with PCM; entrance via CUET UG or university-specific exams.",
    exams: ["CUET UG", "State University Entrance Exams"],
    colleges: [
      "IISc Bengaluru",
      "St. Stephen's College, Delhi",
      "St. Xavier's College, Mumbai",
      "IITs (Integrated M.Sc programs)",
      "University of Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["mechanics", "quantum", "thermodynamics", "experimental physics"],
  },
  {
    id: "bsc-chemistry",
    name: "B.Sc Chemistry",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Chemistry: organic, inorganic, physical chemistry, lab techniques, and research fundamentals.",
    eligibility: "10+2 with PCM/PCB; CUET UG or university entrance exams.",
    exams: ["CUET UG", "State University Entrance Exams"],
    colleges: [
      "IISc Bengaluru",
      "St. Xavier's College, Mumbai",
      "St. Stephen's College, Delhi",
      "IITs (Integrated M.Sc programs)",
      "Delhi University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["organic", "inorganic", "physical chemistry", "laboratory"],
  },
  {
    id: "bsc-maths",
    name: "B.Sc Mathematics",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Mathematics: algebra, calculus, geometry, statistics, applied mathematics, and theoretical foundations.",
    eligibility: "10+2 with Mathematics; CUET UG or university exams.",
    exams: ["CUET UG", "State University Entrance Exams", "IISc Entrance"],
    colleges: [
      "IISc Bengaluru",
      "Indian Statistical Institute (ISI) Kolkata",
      "Chennai Mathematical Institute (CMI)",
      "University of Delhi",
      "Banaras Hindu University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["algebra", "calculus", "statistics", "applied maths"],
  },
  {
    id: "bsc-bio",
    name: "B.Sc Biology / Life Sciences",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Study of organisms: zoology, botany, microbiology, genetics, molecular biology, ecology.",
    eligibility: "10+2 with PCB; CUET UG or state-level entrance exams.",
    exams: ["CUET UG", "State University Entrance Exams"],
    colleges: [
      "IISc Bengaluru",
      "University of Delhi",
      "JNU, New Delhi",
      "Banaras Hindu University",
      "St. Xavier's College, Mumbai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["genetics", "ecology", "microbiology", "botany", "zoology"],
  },
  {
    id: "bsc-astronomy",
    name: "B.Sc Astronomy & Astrophysics",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Physics-heavy study of celestial objects, cosmology, space science, and observational astrophysics.",
    eligibility: "10+2 with PCM; CUET UG or integrated M.Sc programs at IISc/IUCAA.",
    exams: ["CUET UG", "IISc Entrance", "JEST for PG"],
    colleges: [
      "IISc Bengaluru",
      "Indian Institute of Astrophysics, Bengaluru",
      "IUCAA Pune",
      "Raman Research Institute, Bengaluru",
      "Banaras Hindu University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["space", "cosmology", "astrophysics", "celestial"],
  },
  {
    id: "bsc-statistics",
    name: "B.Sc Statistics / Data Science",
    stream: "science",
    category: "pure-sciences",
    summary:
      "Statistics, probability, data analysis, modeling, and applications in finance, research, and industry.",
    eligibility: "10+2 with Mathematics; CUET UG or university entrance exams.",
    exams: ["CUET UG", "ISI Entrance", "CMI Entrance"],
    colleges: [
      "Indian Statistical Institute (ISI) Kolkata",
      "Chennai Mathematical Institute (CMI)",
      "Banaras Hindu University",
      "University of Delhi",
      "IITs (Integrated M.Sc programs)"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["statistics", "probability", "data analysis", "modeling"],
  },
];

export default PURE_SCIENCES;
